import axios from 'axios'
import SERVER_API from './server-list'
import { Fetch } from '../storage'
import {SignIn} from "../login"




const Service = axios.create({
    baseURL: process.env.VUE_APP_API_GATEWAY_URL,
    timeout: 5000
})

Service.interceptors.request.use(
    config => {
        let token = Fetch('Token')
        if (token) {
            config.headers['Authorization'] = token
        }
        return config
    },
    error => {
        Promise.reject(error)
    }
)

Service.interceptors.response.use(
    response => {
        return response.data
    },
    errorResponse => {
        let res = errorResponse.response
        if (res) {
            if (res.status === 401) {
                SignIn()
            } else {
                return Promise.reject(res.data)
            }
        } else {
            return Promise.reject(errorResponse)
        }
    }
)

const Api = async (name, data = {}, params = {},uri = []) => {
    let url = SERVER_API[name].path
    uri.forEach(item => {
        url = url.replace(`:${item.Name}`,item.Value)
    })
    let method = SERVER_API[name].method
    return Service({
        data,
        params,
        url,
        method
    })
}

export {Api}